// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"uw_a bhl_ke","BrandListItem__name":"uw_b bhl_vp"};